import { render } from "./index.vue?vue&type=template&id=233f7965&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=233f7965&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233f7965"]])

export default __exports__